(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  document.querySelectorAll('form#ContactForm').forEach((form) => {
    const summary = form.querySelector('#ContactForm-validation');
    if (!summary || form.dataset.validationReady) return;
    form.dataset.validationReady = 'true';
    form.addEventListener('invalid', (event) => {
      event.target.setAttribute('aria-invalid', 'true');
      summary.textContent = 'Please enter a valid email address and a message before sending.';
      summary.hidden = false;
    }, true);
    form.addEventListener('input', (event) => {
      if (event.target.validity && event.target.validity.valid) event.target.removeAttribute('aria-invalid');
      if (Array.from(form.elements).every((field) => !field.willValidate || field.validity.valid)) summary.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
